import {ORGANIZATION_SERVER} from "@/api";
import RestResource from "@/api/rest/rest-resource";
import {athubAxios} from "@/util";

const user = new RestResource({server: ORGANIZATION_SERVER, resource: 'user'});

user.findByUserName = (username) => {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/user/username/${username}`).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

user.checkPassword = (username, password) => {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/user/checkPassword/${username}/${password}`).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
}


export default user;